import { Controller } from "@hotwired/stimulus";

// Challenge date picker: start date → duration toggle pills → end date computed.
// Matches the day-of-week toggle style from timeslot schedule form.
export default class extends Controller {
  static targets = ["customField", "hiddenEnd"];

  // Inactive classes (match timeslot day toggle)
  static OFF = [
    "bg-gray-100", "text-gray-700", "border-gray-300",
    "dark:bg-gray-700", "dark:text-gray-300", "dark:border-gray-600",
  ];
  // Active classes
  static ON = [
    "bg-primary-600", "text-white", "border-primary-600",
  ];

  setDuration(e) {
    const days = parseInt(e.currentTarget.dataset.days);
    const startInput = this.element.querySelector("input[name*='starts_on']");
    if (!startInput) return;

    if (!startInput.value) {
      startInput.value = new Date().toISOString().split("T")[0];
      startInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    const start = new Date(startInput.value + "T00:00:00");
    const end = new Date(start);
    end.setDate(end.getDate() + days);
    const endStr = end.toISOString().split("T")[0];

    if (this.hasHiddenEndTarget) this.hiddenEndTarget.value = endStr;

    const visibleEnd = this.hasCustomFieldTarget
      ? this.customFieldTarget.querySelector("input[type=date]")
      : null;
    if (visibleEnd) {
      visibleEnd.value = endStr;
      visibleEnd.dispatchEvent(new Event("input", { bubbles: true }));
    }

    if (this.hasCustomFieldTarget) this.customFieldTarget.classList.add("hidden");

    this.activate(e.currentTarget);
  }

  showCustom(e) {
    if (this.hasCustomFieldTarget) {
      this.customFieldTarget.classList.remove("hidden");
      const input = this.customFieldTarget.querySelector("input[type=date]");
      if (input) input.focus();
    }
    this.activate(e.currentTarget);
  }

  activate(active) {
    const buttons = this.element.querySelectorAll(
      "[data-days], [data-action*=showCustom]"
    );

    buttons.forEach((btn) => {
      const on = btn === active;
      this.constructor.OFF.forEach((c) => btn.classList.toggle(c, !on));
      this.constructor.ON.forEach((c) => btn.classList.toggle(c, on));
    });
  }
}
